/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'

const Footer = () => {
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
     <div className='container-fluid'>
  <div className='d-flex flex-column flex-md-row justify-content-center align-items-center w-100'>
    
    <div className='text-dark text-center'>
      <span className='text-muted fw-semibold me-1'>
        {/* {new Date().getFullYear()} &copy; */}
      </span>

      <span className='text-muted me-1'>
        Designed & Developed by:
      </span>

      <a
        href='https://ivotiontech.com/'
        target='_blank'
        rel='noopener noreferrer'
        className='text-gray-800 text-hover-primary fw-semibold'
      >
        Ivotiontech
      </a>

    </div>

  </div>
</div>


      <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
        {/* <li className='menu-item'>
          <a href='https://ivotiontech.com/' target='_blank' className='menu-link px-2'>
            About
          </a>
        </li> */}

        {/* <li className='menu-item'>
          <a href='https://ivotiontech.com/' target='_blank' className='menu-link px-2'>
            Support
          </a>
        </li> */}

        {/* <li className='menu-item'>
          <a
            href='https://ivotiontech.com/'
            target='_blank'
            className='menu-link px-2'
          >
            Purchase
          </a>
        </li> */}
      </ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
